import * as index_java from './index.java'
import * as webapplication_java from './webapplication.java'
import * as acdcController_java from './acdccontroller.java'

export default [index_java, webapplication_java, acdcController_java]
